export default function initHeroBannerSlides(sectionEl) {
  const sectionId = sectionEl.dataset.sectionId;
  if (!sectionId) return;

  const slider = sectionEl.querySelector('.super-hero-slider__slider');
  if (!slider) return;

  const slides = slider.querySelectorAll('.super-hero-slider__slide');
  if (!slides.length) return;

  const dots = slider.querySelectorAll('.super-hero-slider__dot');
  const prevArrow = slider.querySelector('.super-hero-slider__arrow--prev');
  const nextArrow = slider.querySelector('.super-hero-slider__arrow--next');

  const autoplay = slider.getAttribute('data-autoplay') === 'true';
  const speed = parseInt(slider.getAttribute('data-speed'), 10) || 5000;
  const rotatingSpeed = parseInt(slider.getAttribute('data-rotating-speed'), 10) || 1200;

  let currentIndex = 0;
  let autoplayTimer = null;
  const rotatingData = [];

  /* ---------- Rotating text ---------- */
  function initRotatingHeadings() {
    slides.forEach((slide, index) => {
      const dynamicEl = slide.querySelector('.super-hero-slider__rotating-dynamic');
      if (!dynamicEl) return;

      const itemsAttr = dynamicEl.dataset.rotatingItems || '';
      const items = itemsAttr
        .split('|')
        .map(s => s.trim())
        .filter(Boolean);

      if (!items.length) return;

      rotatingData[index] = {
        el: dynamicEl,
        items,
        current: 0,
        timer: null
      };

      dynamicEl.textContent = items[0];
    });
  }

  function stopAllRotations() {
    rotatingData.forEach(data => {
      if (data?.timer) {
        clearInterval(data.timer);
        data.timer = null;
      }
    });
  }

  function startRotationForCurrent() {
    const data = rotatingData[currentIndex];
    if (!data || data.items.length <= 1) return;

    data.timer = setInterval(() => {
      data.current = (data.current + 1) % data.items.length;
      data.el.textContent = data.items[data.current];
    }, rotatingSpeed);
  }

  /* ---------- Slides ---------- */
  function showSlide(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    currentIndex = index;

    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === currentIndex);
    });

    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === currentIndex);
    });

    stopAllRotations();
    startRotationForCurrent();
  }

  function nextSlide() {
    showSlide(currentIndex + 1);
  }

  function prevSlide() {
    showSlide(currentIndex - 1);
  }

  function startAutoplay() {
    if (!autoplay || slides.length <= 1) return;
    stopAutoplay();
    autoplayTimer = setInterval(nextSlide, speed);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  /* ---------- Events ---------- */
  nextArrow?.addEventListener('click', () => {
    nextSlide();
    startAutoplay();
  });

  prevArrow?.addEventListener('click', () => {
    prevSlide();
    startAutoplay();
  });

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const target = parseInt(dot.dataset.slideTarget, 10) || 0;
      showSlide(target);
      startAutoplay();
    });
  });

  slider.addEventListener('mouseenter', stopAutoplay);
  slider.addEventListener('mouseleave', startAutoplay);

  /* ---------- Init ---------- */
  initRotatingHeadings();
  showSlide(0);
  startAutoplay();
}
